import { useState, useEffect } from "react";
import { message } from "antd";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { AI_TIMEOUT, startAILoading } from "api/aiLoading";
import { JobApplicationStatusEnum } from "Constants/Enums/JobApplicantStatusEnum";

export default function FeedBack(jobPostingId) {
  const [openfeedback, setOpenfeedback] = useState(false);
  const [feedbackEmployeeId, setFeedBackEmployeeId] = useState(null);
  const [feedbacks, setFeedbacks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!jobPostingId) return;
    fetchApplicants(jobPostingId);
  }, [jobPostingId]);

  const fetchApplicants = async (id) => {
    try {
      const response = await axiosInstance.get(API.hiringJobApplicant.getListByPosting(id));

      const applicants = response.data.applicants || [];

      const mapped = applicants.map((info) => ({
        key: info.jobApplicantId.toString(),
        jobApplicantId: info.jobApplicantId,
        email: info.email,
        status: info.status,
        emailSent: info.emailSent,
        canGiveFeedback:
          info.status === JobApplicationStatusEnum.Interview ||
          info.status === JobApplicationStatusEnum.FeedbackAdded,
      }));

      setFeedbacks(mapped);
    } catch (error) {
      console.error("Error fetching applicants:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const showfeedbackModal = (jobApplicantId) => {
  setFeedBackEmployeeId(jobApplicantId);
  setFeedbackData({
    technicalSkills: 1,
    communication: 1,
    problemSolving: 1,
    experienceFit: 1,
    teamFit: 1,
    overallRating: 1,
    strengths: "",
    concerns: "",
    keyObservations: "",
  });
  setOpenfeedback(true);
};

  const [feedbackData, setFeedbackData] = useState({
  technicalSkills: 1,
  communication: 1,
  problemSolving: 1,
  experienceFit: 1,
  teamFit: 1,
  overallRating: 1,
  strengths: "",
  concerns: "",
  keyObservations: "",
});

  const handleSubmitFeedback = async () => {
  const numericFields = [
    feedbackData.technicalSkills,
    feedbackData.communication,
    feedbackData.problemSolving,
    feedbackData.experienceFit,
    feedbackData.teamFit,
    feedbackData.overallRating,
  ];

  const isValid = numericFields.every((val) => val >= 1 && val <= 10);

  if (!isValid) {
    message.error("All scores must be between 1 and 10");
    return;
  }

  let stopAILoading;
  try {
    const total = numericFields.reduce((a, b) => a + b, 0);
    const payload = {
      jobApplicantId: feedbackEmployeeId,
      ...feedbackData,
      marksAverage: total / 6,
    };
    // Provide-feedback triggers AI re-evaluation, so bump timeout and show
    // rotating loading messages.
    stopAILoading = startAILoading();
    await axiosInstance.post(API.feedback.provideFeedback, payload, {
      timeout: AI_TIMEOUT,
    });
    message.success("Feedback submitted successfully");
    setOpenfeedback(false);
    fetchApplicants(jobPostingId);
  } catch (error) {
    console.error(error);
    message.error("Failed to submit feedback");
  } finally {
    if (stopAILoading) stopAILoading();
  }
};

  return {
    feedbacks,
    openfeedback,
    setOpenfeedback,
    showfeedbackModal,
    feedbackData,
    setFeedbackData,
    handleSubmitFeedback,
    isLoading,
  };
}
